"use client";

import { useEffect } from "react";

/**
 * Hook that triggers a callback on the first user interaction
 * Listens for: click, touchstart, keydown
 * Automatically removes listeners after first interaction
 */
export function useFirstInteraction(callback: () => void): void {
  useEffect(() => {
    let hasInteracted = false;

    const handleInteraction = () => {
      if (!hasInteracted) {
        hasInteracted = true;
        callback();
        // Remove all listeners after first interaction
        window.removeEventListener("click", handleInteraction);
        window.removeEventListener("touchstart", handleInteraction);
        window.removeEventListener("keydown", handleInteraction);
      }
    };

    // Add listeners for different interaction types
    window.addEventListener("click", handleInteraction);
    window.addEventListener("touchstart", handleInteraction);
    window.addEventListener("keydown", handleInteraction);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("click", handleInteraction);
      window.removeEventListener("touchstart", handleInteraction);
      window.removeEventListener("keydown", handleInteraction);
    };
  }, [callback]);
}
